import { createApi } from '@reduxjs/toolkit/query/react';
import { BackendResponse } from '../../types';
import { parseQueryParams } from '../../utils';
import { SystemStatus } from '../../enums';
import {
  IApprovalLevel,
  ISystemModules,
} from '../../pages/Settings/constants/settings.interface';
import { baseQueryWithReauth } from './baseQuery';

const settingsApi = createApi({
  reducerPath: 'settings',
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    'ApprovalConfig',
    // 'ApprovalConfigReport',
  ],
  endpoints: builder => ({
    getSystemModules: builder.query<
      BackendResponse<{ list: ISystemModules[]; count: number | null }>,
      { hasApproval: SystemStatus }
    >({
      query: (params = { hasApproval: SystemStatus.ACTIVE }) => ({
        url: `/settings/system-modules${parseQueryParams(params)}`,
        method: 'GET',
      }),
    }),
    getApprovalConfigFromModule: builder.query<
      BackendResponse<{ list: IApprovalLevel[] }>,
      { moduleName: string }
    >({
      query: (params: { moduleName: string }) => ({
        url: `/settings/approvals${parseQueryParams(params)}`,
        method: 'GET',
      }),
      providesTags: (_, error) => {
        if (error) {
          return [];
        }
        return ['ApprovalConfig'];
      },
    }),
    createApprovalConfigForModule: builder.mutation<BackendResponse<void>, any>(
      {
        query: payload => ({
          url: '/settings/approvals',
          method: 'POST',
          body: payload,
        }),
        invalidatesTags: (__, error) => {
          if (error) {
            return [];
          }
          return ['ApprovalConfig'];
        },
      },
    ),
    getAllStatus: builder.query<BackendResponse<any>, void>({
      query: () => ({
        url: '/settings/status',
        method: 'GET',
      }),
    }),
    getAllAction: builder.query<BackendResponse<any>, void>({
      query: () => ({
        url: '/settings/actions',
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useGetSystemModulesQuery,
  useGetApprovalConfigFromModuleQuery,
  useLazyGetApprovalConfigFromModuleQuery,
  useCreateApprovalConfigForModuleMutation,
  useGetAllActionQuery,
  useGetAllStatusQuery,
} = settingsApi;

export default settingsApi;
